







import { Component, Vue } from "vue-property-decorator";
import { namespace } from "vuex-class";
import { AccessLogUserModel } from "../models";

import AccessLogUsers from "../components/AccessLogUsers.vue";
import AccessLogFilter from "../components/AccessLogFilter.vue";

const iStore = namespace("invoices");
const snackStore = namespace("snackbar");

@Component({
  components: { AccessLogUsers, AccessLogFilter },
})
export default class AccessLogs extends Vue {
  @iStore.Getter allAccessLogs!: AccessLogUserModel[];

  @iStore.Action fetchAccessLogs!: () => Promise<void>;

  @snackStore.Mutation defaultError!: () => void;

  filteredLogs: AccessLogUserModel[] = [];

  mounted(): void {
    this.fetchAccessLogs().catch(() => {
      this.defaultError();
    });
  }
}
